import React, { useState } from "react";
import styles from "styles/onboarding.module.css";
import localStyles from "./register-admin.module.css";
import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import axios from "services/api";
import { useNavigate } from "react-router";
import tokenService from "services/token.service";
import Spinner from "components/functional/spinner";
import LanguageSelector from "components/functional/language-selector";
import RegisterPresentation from "components/register/register-presentation";
import useIsMobile from "hooks/detect-mobile-screen";
import { ToastService, ToastComponent } from "services/toast.service";

const RegisterAdmin = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const isMobile = useIsMobile(980);

  const validateForm = () => {
    const newErrors = {};
    if (!email) newErrors.email = t("errors.required");
    if (!password) newErrors.password = t("errors.required");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!validateForm()) return;
      const response = await axios.post("auth/register-admin", {
        email,
        password,
      });
      const token = response.data.token;
      tokenService.setToken(token);
      navigate("/register-admin-success");
    } catch (e) {
      if (e.response?.status === 409) {
        ToastService.showErrorToast(t("toast.register-duplicate-user"));
      } else {
        ToastService.showErrorToast(t("toast.register-error"));
      }
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles["register-container"]}>
      <ToastComponent />
      <section className={styles["register-content"]}>
        <div className={styles["content-header"]}>
          <div className="company-logo">
            <img src="logo.png" width="26" height="24" alt="" />
            <h1 className="title-2-variant">Kompa</h1>
          </div>
          {!isMobile && (
            <NavLink className="link-1" to="/login">
              {t("actions.sign-in")}
            </NavLink>
          )}
          <LanguageSelector></LanguageSelector>
        </div>
        <div className={styles["content-actions"]}>
          <article className={localStyles.register}>
            <header className={styles["role-header"]}>
              <h2 className="title-1-variant">
                {t("register.form-step.title")}
              </h2>
              <p className="subtitle-1-variant">
                {t("register.form-step.description")}
              </p>
            </header>
            <form onSubmit={handleRegister} className={localStyles.wrapper}>
              <div className={localStyles.form}>
                <div className="form-group">
                  <label htmlFor="email">{t("login.form.email.title")}</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrors({ ...errors, email: null });
                    }}
                    placeholder={t("login.form.email.placeholder")}
                    className={errors.email && "error"}
                  />
                  {errors.email && (
                    <p className="error-message">{t("errors.required")}</p>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="password">
                    {t("login.form.password.title")}
                  </label>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrors({ ...errors, password: null });
                    }}
                    placeholder={t("login.form.password.placeholder")}
                    className={errors.password && "error"}
                  />
                  {errors.password && (
                    <p className="error-message">{t("errors.required")}</p>
                  )}
                </div>
                <button type="submit" className="btn btn--primary">
                  {t("register.form-step.cta")}
                  {loading && <Spinner className="action-loader" />}
                </button>
              </div>
            </form>
            <div className={styles["role-back-cta"]}>
              <button
                className="btn btn--secondary btn--icon-label"
                onClick={() => navigate("/register")}
              >
                <ChevronLeft size={20} />
                <p className="subtitle-1-variant">{t("actions.back")}</p>
              </button>
            </div>
          </article>
        </div>
      </section>
      {!isMobile && <RegisterPresentation />}
    </div>
  );
};

export default RegisterAdmin;
